import { CommonModule } from '@angular/common';
import { Component, inject, viewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';

@Component({
  selector: 'app-privacy-policy',
   standalone: true,
  imports: [TranslateModule, CommonModule, SafeHtmlPipe],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],

})
export class PrivacyPolicyComponent {
  isOuterRoute = false;
  privacyData: any;
  SafeHtmlPipe!: SafeHtmlPipe;
  pageService = inject(PagesService)
  sharedService = inject(SharedService);


  constructor() { }
  ngOnInit(): void {
    const hash = window.location.hash;
    const path = hash.replace(/^#/, '');
    this.isOuterRoute = path === '/privacy-policy';

    this.loadPrivacyPolicy();
  }

  loadPrivacyPolicy() {
    // Loader show kar do
    this.sharedService.showLoader();

    this.pageService.getAll('GET_PRIVACY_POLICY').subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          this.privacyData = res[0];
        }
      },
      error: (err: any) => {
        console.error('Failed to load privacy policy', err);
        // Agar error aaye to bhi loader hide kar do
        this.sharedService.hideLoader();
      },
      complete: () => {
        // Request complete hone par loader hide kar do
        this.sharedService.hideLoader();
      }
    });
  }

}